export interface InventoryPhoneRecord {
  id:number;
  type:'STOCK_IN'|'PICKUP'|'RETURN'|'SALE'|'REALLOCATION'|'CUSTOMER_RETURN'|'STOCK_TRANSFER';
  reference?:string|null;
  status:string;
  stockPointName?:string|null;
  personName?:string|null;
  otherPersonName?:string|null;
  timeZone:string;
  occurredAt?:string|null;
  canOpen:boolean;
}
export interface InventoryPhone {
  id:number;
  countryCode:string;
  skuName:string;
  status:string;
  stockPointId:number;
  stockTransferId?:number|null;
  transferSourceName?:string|null;
  transferTargetName?:string|null;
  stockPointName:string;
  timeZone:string;
  custodianName?:string|null;
  custodianAccount?:string|null;
  custodianPhone?:string|null;
  salesDueAt?:string|null;
  updatedAt?:string|null;
  imeis:string[];
  records:InventoryPhoneRecord[];
}
export const phoneWithAgent=(status:string)=>['IN_SALES_CUSTODY','SALE_UNLOCK_PENDING','RETURN_OVERDUE','LOCKED_RETURN_OVERDUE'].includes(status);
export function inventoryPhoneStatus(status:string){
  const labels:Record<string,string>={
    STOCK_IN_TRANSIT:'Stock transfer · awaiting receipt',INSTALLATION_PENDING:'Setup pending',PRE_SALE_LOCK_PENDING:'Stock-in · waiting for lock',
    READY_TO_STOCK:'Ready to stock in',AVAILABLE_FOR_SALE:'Available for sale',
    PICKUP_PENDING:'Awaiting handover review',IN_SALES_CUSTODY:'With agent',
    SALE_UNLOCK_PENDING:'Sale confirmation pending',RETURN_OVERDUE:'Return overdue',
    LOCKED_RETURN_OVERDUE:'Return overdue',RETURN_PRE_SALE_LOCK_PENDING:'Returned · waiting for lock',
    SOLD:'Sold',RETURNED_PENDING_REFURB:'Awaiting refurbishment',PENDING_REFURBISHMENT:'Awaiting refurbishment',
  };
  return labels[status]??'Status unavailable';
}
export function phoneLocation(phone:InventoryPhone){
  if(phone.status==='STOCK_IN_TRANSIT')return `${phone.transferSourceName} → ${phone.transferTargetName}`;
  if(phoneWithAgent(phone.status))return phone.custodianName??phone.custodianAccount??'Agent not recorded';
  if(phone.status==='SOLD')return 'With customer';
  if(['INSTALLATION_PENDING','PRE_SALE_LOCK_PENDING','READY_TO_STOCK','AVAILABLE_FOR_SALE','PICKUP_PENDING','RETURN_PRE_SALE_LOCK_PENDING','RETURNED_PENDING_REFURB','PENDING_REFURBISHMENT'].includes(phone.status))return phone.stockPointName;
  return 'Location not confirmed';
}
export function phoneNextStep(phone:InventoryPhone){
  if(phone.status==='STOCK_IN_TRANSIT')return 'This phone has left its source stock point. Track receipt in the stock transfer below.';
  if(phone.status==='RETURN_PRE_SALE_LOCK_PENDING')return 'The stock point has received this phone. It is not available for pickup until its pre-sale lock is confirmed.';
  if(['INSTALLATION_PENDING','PRE_SALE_LOCK_PENDING','READY_TO_STOCK'].includes(phone.status))return 'Stock-in is unfinished. Open the stock-in record below to continue.';
  if(phone.status==='PICKUP_PENDING')return 'This phone was scanned for pickup and is awaiting Stock Keeper review. Open the pickup record below.';
  if(phone.status==='SALE_UNLOCK_PENDING')return 'The phone is still assigned to the agent while the sale is being confirmed.';
  if(phone.status==='SOLD')return 'The completed sale is recorded. This phone is no longer in stock-point inventory or agent custody.';
  return '';
}
export function phoneRecordLabel(record:InventoryPhoneRecord){
  if(record.type==='STOCK_TRANSFER')return ({COMPLETED:'Stock transfer completed',CANCELLED:'Stock transfer cancelled',IN_TRANSIT:'Stock transfer awaiting receipt',READY:'Stock transfer awaiting dispatch'} as Record<string,string>)[record.status]??'Stock transfer';
  if(record.type==='STOCK_IN')return record.status==='COMPLETED'?'Stock-in completed':'Stock-in in progress';
  if(record.type==='PICKUP')return ({COMPLETED:'Collected by agent',CANCELLED:'Pickup cancelled',PENDING_REVIEW:'Pickup awaiting review',EXPIRED:'Pickup expired'} as Record<string,string>)[record.status]??'Pickup in progress';
  if(record.type==='RETURN')return record.status==='COMPLETED'?'Returned to stock':record.status==='LOCK_PENDING'?'Phone received · waiting for lock':'Phone return in progress';
  if(record.type==='SALE')return record.status==='COMPLETED'?'Sale completed':'Sale confirmation pending';
  if(record.type==='CUSTOMER_RETURN')return record.status==='COMPLETED'?'Customer return completed':record.status==='CANCELLED'?'Customer return cancelled':'Customer return in progress';
  return ({COMPLETED:'Reallocated',CANCELLED:'Reallocation cancelled',DECLINED:'Reallocation declined',EXPIRED:'Reallocation expired'} as Record<string,string>)[record.status]??'Reallocation in progress';
}
export function phoneRecordPath(record:InventoryPhoneRecord){
  if(!record.canOpen)return undefined;
  if(record.type==='STOCK_IN'&&record.status!=='COMPLETED')return `/stock-in/${record.id}`;
  if(record.type==='PICKUP')return `/pickups/${record.id}`;
  if(record.type==='STOCK_TRANSFER')return `/stock-transfers/${record.id}`;
  return undefined;
}
